/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Insurances/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Insurance from './Insurance/index'
import MissingOrthoCoverage from './MissingOrthoCoverage/index'
import React from 'react'
import RemoveInsurance from './RemoveInsurance/index'
import Summary from './Summary/index'
import ToggleInsurance from './ToggleInsurance/index'
import TysiaCollapsible from 'DesignSystem/TysiaCollapsible/index'
import TysiaCollapsibleCollapsed from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleCollapsed/index'
import TysiaCollapsibleContent from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleContent/index'
import TysiaCollapsibleHeader from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleHeader/index'
import TysiaCollapsibleIcon from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleIcon/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Tysiav2Insurance from 'DesignSystem/Svgs/Tysiav2Insurance/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Insurances({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances"
  
}) {
let collapsibleIsCollapsedValueData = fromData.useDataValue({ viewPath,
context: 'collapsible',
path: 'is_collapsed',
})
let onToggle = fromHelpers.useOnToggle({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let paymentPlanInsurancesValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'insurances',
})
  return (<React.Fragment
>
<TysiaCollapsible
  viewPath={`${viewPath}/TysiaCollapsible`}
 data="collapsible.is_collapsed"
 isOpen={!collapsibleIsCollapsedValueData}
 onToggle={onToggle}
>
{childProps => (
<React.Fragment>
<TysiaCollapsibleHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleHeader`}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 backgroundColor={dtColorsNeutral100}
 borderBottomStyle="solid"
 borderBottomWidth={1}
 borderBottomColor={dtColorsNeutral200}
 alignItems="center"
>
{childProps => (
<React.Fragment>
<Tysiav2Insurance
{...childProps}
  viewPath={`${viewPath}/Tysiav2Insurance`}
/>
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 text="Insurances"
 level="h4"
 marginTop={0}
 marginLeft={dtSpaceXs}
/>
<ToggleInsurance
{...childProps}
  viewPath={`${viewPath}/ToggleInsurance`}
/>
<TysiaCollapsibleCollapsed
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleCollapsed`}
>
{childProps => (
<Summary
{...childProps}
  viewPath={`${viewPath}/Summary`}
/>
)}
</TysiaCollapsibleCollapsed>
<TysiaCollapsibleIcon
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleIcon`}
/>
</React.Fragment>
)}
</TysiaCollapsibleHeader>
<TysiaCollapsibleContent
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleContent`}
>
{childProps => (
<React.Fragment>
<MissingOrthoCoverage
{...childProps}
  viewPath={`${viewPath}/MissingOrthoCoverage`}
/>
<div
  data-testid="Insurances.List"
  data-view-path={viewPath}
 style={{'--bbc-1-Z2EOgb': dtColorsNeutral200,'--pb-2-Z2EOgb': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-Z2EOgb': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-4-Z2EOgb': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-5-Z2EOgb': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(paymentPlanInsurancesValueData) && paymentPlanInsurancesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="insurance"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Insurance(${item?.id ?? item?._id ?? index})`}
      >
<Insurance
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Insurance(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</React.Fragment>
)}
</TysiaCollapsibleContent>
</React.Fragment>
)}
</TysiaCollapsible>
<RemoveInsurance
  viewPath={`${viewPath}/RemoveInsurance`}
/>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }